// Componente de skeleton para la configuración general - Skeleton component for general configuration
// Muestra placeholders que respetan la estructura de tabs y accordions
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@shared/components/ui/shadcn/tabs';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@shared/components/ui/shadcn/accordion';

export const GeneralSkeleton = () => {
  return (
    <Tabs defaultValue="to_prepare" className="w-full p-6">
      {/* Tab Header Skeleton - Skeleton del encabezado de tabs */}
      <div className="flex items-center justify-between mb-4">
        <TabsList>
          <TabsTrigger value="to_prepare">
            <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
          </TabsTrigger>
          <TabsTrigger value="rejected">
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
          </TabsTrigger>
        </TabsList>
        {/* Botón Guardar - Save button */}
        <Skeleton className="h-10 w-24 rounded-full absolute right-3 sm:right-6 top-3 bg-hover-press" />
      </div>

      {/* Tab Content: To Prepare - Contenido de tab: Para Preparar */}
      <TabsContent value="to_prepare">
        <Skeleton className="h-8 w-48 rounded-full mb-4 bg-hover-press" />
        <Accordion type="multiple" defaultValue={['multiple-criteria']} className="w-full">
          {/* Accordion Item 1 - Multiple Criteria */}
          <AccordionItem value="multiple-criteria">
            <AccordionTrigger>
              <Skeleton className="h-5 w-48 rounded-full bg-hover-press" />
            </AccordionTrigger>
            <AccordionContent className="space-y-4">
              {/* Alert Skeleton - Skeleton del alert */}
              <div className="flex items-start gap-3 p-4 border rounded-lg">
                <Skeleton className="h-4 w-4 rounded-full mt-1 bg-hover-press" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-5 w-64 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-3/4 rounded-full bg-hover-press" />
                </div>
              </div>

              {/* Radio Group Skeleton - Skeleton del grupo de radio */}
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-32 bg-hover-press" />
                </div>
                <div className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-40 bg-hover-press" />
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>

          {/* Accordion Item 2 - Packs or Products */}
          <AccordionItem value="packs-or-products">
            <AccordionTrigger>
              <Skeleton className="h-5 w-40 bg-hover-press" />
            </AccordionTrigger>
            <AccordionContent className="space-y-4">
              {/* Alert Skeleton - Skeleton del alert */}
              <div className="flex items-start gap-3 p-4 border rounded-lg">
                <Skeleton className="h-4 w-4 rounded-full mt-1 bg-hover-press" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-5 w-56 bg-hover-press" />
                  <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-4/5 bg-hover-press" />
                </div>
              </div>

              {/* Radio Group Skeleton - Skeleton del grupo de radio */}
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-28 bg-hover-press" />
                </div>
                <div className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-36 bg-hover-press" />
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </TabsContent>

      {/* Tab Content: Rejected - Contenido de tab: Rechazados */}
      <TabsContent value="rejected">
        <Skeleton className="h-8 w-40 mb-4 bg-hover-press" />
        <Accordion type="multiple" defaultValue={['max-qty']} className="w-full">
          {/* Accordion Item - Max Qty */}
          <AccordionItem value="max-qty">
            <AccordionTrigger>
              <Skeleton className="h-5 w-32 bg-hover-press" />
            </AccordionTrigger>
            <AccordionContent className="space-y-4">
              {/* Alert Skeleton - Skeleton del alert */}
              <div className="flex items-start gap-3 p-4 border rounded-lg">
                <Skeleton className="h-4 w-4 rounded-full mt-1 bg-hover-press" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-5 w-52 bg-hover-press" />
                  <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-5/6 bg-hover-press" />
                </div>
              </div>

              {/* Radio Group Skeleton - Skeleton del grupo de radio */}
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                </div>
                <div className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </TabsContent>
    </Tabs>
  );
};

